/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';
var fixedHeightStyles = css({
  height: "".concat(gridSize() * 18, "px")
});
export var EmptyViewWithFixedHeight = function EmptyViewWithFixedHeight(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: fixedHeightStyles
  }, children);
};
var emptyViewContainerStyles = css({
  margin: 'auto',
  padding: '10px',
  textAlign: 'center',
  width: '50%'
});
export var EmptyViewContainer = function EmptyViewContainer(_ref2) {
  var children = _ref2.children;
  return jsx("div", {
    css: emptyViewContainerStyles
  }, children);
};